import Vue from "vue";
import App from "./App.vue";
import Plugins from "./plugins";
import store from "./store";
import router from "./router";
import Components from "@/components";
import "@vant/touch-emulator";

import "@/assets/style.less";

import "@/assets/swiper-bundle.min.css";
const Swiper = require("@/assets/js/swiper-bundle.min.js");
window.Swiper = Swiper;
import CryptoJS from "crypto-js";
// 将CryptoJS添加到全局window对象
window.CryptoJS = CryptoJS;
import VConsole from "@/assets/js/vconsole.min.js";

// 在开发环境下引入vConsole
if (process.env.VUE_APP_API_URL == "http://api.yun.fgcq.info") {
  const vConsole = new VConsole();
}

Vue.config.productionTip = false;

Vue.use(Plugins);
Vue.use(Components);

import myPopup from "./mypopup";
Vue.prototype.$mypopup = myPopup;
import { startVersionCheck } from "@/utils/versionCheck";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

startVersionCheck();